import { Flex } from '@ifood/pomodoro-components';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React from 'react';

import ErrorImg from 'images/error-illustration.svg';

import { Actions, Content, Description, Image, ReloadButton, Title } from './styles';

export type PropTypes = {
  imgWidth?: string;
  imgHeight?: string;
  imgAlt?: string;
  imgSrc?: string;
  titleIntlKey?: string;
  descriptionIntlKey?: string;
  actionLabelIntlKey?: string;
  onActionClick?: () => void;
  onSecondaryActionClick?: () => void;
  secondaryActionIntlKey?: string;
  className?: string;
};

export const ErrorFallback = ({
  imgWidth = '610px',
  imgHeight = '500px',
  imgAlt = '',
  imgSrc = ErrorImg,
  titleIntlKey = 'error.message.title',
  descriptionIntlKey = 'error.message.description',
  actionLabelIntlKey = 'error.message.reload',
  secondaryActionIntlKey = 'error.message.reload',
  onSecondaryActionClick,
  onActionClick,
  className,
}: PropTypes): JSX.Element => (
  <Flex flexDirection="column" alignItems="center" className={className}>
    <Image src={imgSrc} alt={imgAlt} width={imgWidth} height={imgHeight} />
    <Content flexDirection="column" alignItems="center">
      <FormattedMessage id={titleIntlKey}>{(text): JSX.Element => <Title>{text}</Title>}</FormattedMessage>

      <FormattedMessage id={descriptionIntlKey}>
        {(text): JSX.Element => <Description>{text}</Description>}
      </FormattedMessage>

      <Actions>
        {onSecondaryActionClick && (
          <ReloadButton variant="secondary" onClick={onSecondaryActionClick}>
            <FormattedMessage id={secondaryActionIntlKey} />
          </ReloadButton>
        )}
        {onActionClick && (
          <ReloadButton onClick={onActionClick}>
            <FormattedMessage id={actionLabelIntlKey} />
          </ReloadButton>
        )}
      </Actions>
    </Content>
  </Flex>
);
